<template>
  <div class='indexbox'>
    <div class="searchbox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="val.shop_name" :name="val.id_tostrign" v-for="val in tablist" :key="val.shop_name">
        </el-tab-pane>
      </el-tabs>
      <div class="headersbox" v-if="tablist.length>0">
        <el-form ref="form" size="small" inline>
          <el-form-item>
            <el-input v-model="keywords" :placeholder="$t('lg.输入并搜索')" style="width: 130px" clearable @change="pagechage(1)"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lg.订单日期')">
            <el-date-picker v-model="timearr" style="width:230px" format='yyyy-MM-dd' value-format="yyyy-MM-dd" type="daterange" range-separator="-" :start-placeholder="$t('lg.开始日期')" :end-placeholder="$t('lg.结束日期')" clearable @change="pagechage(1)" />
          </el-form-item>
          <el-form-item :label="$t('lg.同步日期')">
            <el-date-picker v-model="execution" style="width:230px" format='yyyy-MM-dd' value-format="yyyy-MM-dd" type="daterange" range-separator="-" :start-placeholder="$t('lg.开始日期')" :end-placeholder="$t('lg.结束日期')" clearable @change="pagechage(1)" />
          </el-form-item>
          <el-form-item :label="$t('lg.同步状态')">
            <el-select v-model="order_status" :placeholder="$t('lg.请选择')" clearable style="width:100px" @change="pagechage(1)">
              <el-option v-for="item in order_statusdata" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lg.同步事件')">
            <el-select v-model="type" :placeholder="$t('lg.请选择')" clearable style="width:100px" @change="pagechage(1)">
              <el-option v-for="item in type_statusdata" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="rightbox">
          <!-- <el-button type="primary" icon="el-icon-search" circle @click="pagechage(1)">{{$t('lg.查询')}}</el-button> -->
          <el-button type="primary" v-hasPermi="['orders_jump']" :loading='loadinga' @click="allbatSkip">{{$t('lg.跳过')}}</el-button>
          <el-button type="primary" v-hasPermi="['orders_sys']" :loading='loadingb' @click="allbatSynchronize">{{$t('lg.同步')}}</el-button>
        </div>
      </div>
    </div>
    <div class="tablebox">
      <div class="draggable" v-loading='loading'>
        <el-table :data="tableData" stripe @selection-change="SelectionChange" max-height='680px' border>
          <el-table-column type="selection" fixed align='center' />
          <el-table-column prop="ref_oid" :label="$t('lg.平台订单编号')" min-width="110" fixed="left" align='center' show-overflow-tooltip />
          <el-table-column prop="order_time" :label="$t('lg.订单日期')" min-width="120" sortable align='center' show-overflow-tooltip />
          <el-table-column prop="total_amount" :label="$t('lg.订单金额')" min-width="110" align='center' show-overflow-tooltip />
          <el-table-column prop="dear_sn" :label="$t('lg.DEAR订单编号')" min-width="120" align='center' show-overflow-tooltip />
          <el-table-column prop="create_time" :label="$t('lg.同步日期')" min-width="120" sortable align='center' show-overflow-tooltip />
          <el-table-column prop="order_status" :label="$t('lg.同步状态')" min-width="110" align='center' show-overflow-tooltip>
            <template slot-scope="scope">
              <p>{{order_status_fun(scope.row.status)}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="order_status" :label="$t('lg.同步事件')" min-width="110" align='center' show-overflow-tooltip>
            <template slot-scope="scope">
              <p style="text-align:left">{{type_status_fun(scope.row.type)}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('lg.详细描述')" min-width="120" align='center' show-overflow-tooltip />
          <el-table-column align='center' fixed='right' min-width="80">
            <template slot-scope="scope">
              <!-- <el-popconfirm :title="$t('lg.确定要执行跳过')" @confirm='confirmskip(scope.row)'>
                <el-button slot="reference" type="primary" style="margin:0 10px 5px 0" v-if="scope.row.status==0||scope.row.status==2" size="small">{{$t('lg.跳过')}}</el-button>
              </el-popconfirm>
              <el-popconfirm :title="$t('lg.确定要执行同步')" @confirm='confirmsynchronize(scope.row)'>
                <el-button slot="reference" type="primary" style="margin:0 10px 5px 0" v-if="scope.row.status==4||scope.row.status==2" size="small">{{$t('lg.同步')}}</el-button>
              </el-popconfirm> -->
              <!-- <el-button type="text" v-if="scope.row.status==1||scope.row.status==3" size="small">{{order_status_fun(scope.row.status)}}</el-button> -->
              <el-button type="text" size="small" @click="lookdata(scope.row)">{{$t('lg.详情')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change='pagechage' @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" background layout="total,sizes,prev,pager, next" v-show="total>0" :current-page.sync="page" :page-size="page_size" :total="total" />

      <el-dialog :title="$t('lg.订单详情')" :visible.sync="show" width="80%" @close='order_id=""'>
        <div class="tablebox">
          <el-form ref="form" :model="info" class="formbox">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item>
                  <span class="form_tit">{{$t('lg.平台订单号')}}</span>
                  <el-input v-model="info.ref_oid" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <span class="form_tit">{{$t('lg.订单下单日期')}}</span>
                  <el-input v-model="info.order_time" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <span class="form_tit">{{$t('lg.订单金额')}}</span>
                  <el-input v-model="info.total_amount" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div>
            <el-table :data="gooddata" stripe border max-height="400">
              <el-table-column :label="$t('lg.商品名称')" prop="title" align="left" show-overflow-tooltip />
              <el-table-column :label="$t('lg.数量')" prop="num" align="center" show-overflow-tooltip />
              <el-table-column :label="$t('lg.总价')" prop="totalPrice" align="center" show-overflow-tooltip />
              <el-table-column :label="$t('lg.状态')" prop="status" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p>{{order_status_funs(scope.row.status)}}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('lg.退款状态')" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p>{{refund_status_fun(scope.row.refund_status)}}</p>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    data() {
      return {
        tablist: [],
        activeName: '',
        keywords: '',
        timearr: [],
        execution: [],
        order_status: '',
        order_statusdata: [
          { label: this.$t('lg.全部'), value: '' },
          { label: this.$t('lg.待同步'), value: 0 },
          { label: this.$t('lg.成功'), value: 1 },
          { label: this.$t('lg.失败'), value: 2 },
          { label: this.$t('lg.同步中'), value: 3 },
          { label: this.$t('lg.跳过'), value: 4 },
        ],
        type: '',
        type_statusdata: [
          { label: this.$t('lg.全部'), value: '' },
          { label: this.$t('lg.下载订单'), value: 1 },
          { label: this.$t('lg.下载平台发货信息到DEAR'), value: 2 },
          { label: this.$t('lg.上传DEAR发货信息到平台'), value: 3 },
          { label: this.$t('lg.下载订单退货'), value: 4 },
          { label: this.$t('lg.作废销售订单'), value: 5 },
          { label: this.$t('lg.回传平台发货信息到DEAR'), value: 6 },
        ],
        total: 0,
        page_size: 10,
        page: 1,
        tableData: [],
        loading: false,
        goodsList: [],
        btn_loading: false,
        btn_loadinga: false,
        btn_loadingb: false,
        // 订单详情
        show: false,
        order_id: '',
        info: {},
        gooddata: [],
        idsarr: [],
        loadinga: false,
        loadingb: false,
      };
    },
    methods: {
      // tab 店铺
      gettablist() {
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            page: 1,
            page_size: 1000,
            api_id: this.api_id
          },
          success: (res) => {
            res.data.data.forEach(item => {
              item.id_tostrign = item.id.toString()
            });
            this.tablist = res.data.data

            if (this.tablist.length > 0) {
              if (sessionStorage.getItem("orderList_activeName")) {
                this.activeName = sessionStorage.getItem("orderList_activeName")
              } else {
                this.activeName = res.data.data[0].id_tostrign
              }
            } else {
              sessionStorage.removeItem("orderList_activeName")
            }

            this.$nextTick(() => {
              this.getlist()
            })
          },
          tip: () => {
          },
        })
      },
      handleClick(tab) {
        sessionStorage.setItem("orderList_activeName", tab.name)
        this.activeName = tab.name
        this.pagechage(1)
      },
      // 列表
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/order_queue/pageList",
          data: {
            shop_id: this.activeName,
            keywords: this.keywords,
            page: this.page,
            page_size: this.page_size,
            order_start_time: this.timearr && this.timearr.length ? this.timearr[0] : '',
            order_end_time: this.timearr && this.timearr.length ? this.timearr[1] : '',
            execution_start_time: this.execution && this.execution.length ? this.execution[0] : '',
            execution_end_time: this.execution && this.execution.length ? this.execution[1] : '',
            type: this.type,
            status: this.order_status,
          },
          success: (res) => {
            if (res.data.total) {
              this.tableData = res.data.data
              this.total = res.data.total
              this.page_size = Number(res.data.per_page)
              this.page = res.data.current_page
            }
            setTimeout(() => {
              this.loading = false
            }, 200);
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      // 分页
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
      handleSizeChange(size) {
        this.page_size = size
        this.tableData = []
        this.getlist()
      },
      SelectionChange(data) {
        this.idsarr = data
      },
      // 批量跳过
      allbatSkip() {
        if (!this.idsarr.length) {
          this.$message({
            message: this.$t('lg.请选择要跳过的订单'),
            type: 'warning'
          });
          return
        }
        let ids = []
        this.idsarr.map((item) => {
          ids.push(item.id)
        })
        this.loadinga = true
        this.$post({
          url: "/app/order_queue/batSkip",
          data: {
            shop_id: this.activeName,
            ids: ids.join()
          },
          success: res => {
            this.$notify({
              title: this.$t('lg.成功'),
              type: 'success'
            });
            setTimeout(() => {
              this.loadinga = false
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => {
            setTimeout(() => {
              this.loadinga = false
            }, 1300);
          },
        })
      },
      // 批量同步
      allbatSynchronize() {
        if (!this.idsarr.length) {
          this.$message({
            message: this.$t('lg.请选择要同步的订单'),
            type: 'warning'
          });
          return
        }
        let ids = []
        this.idsarr.map((item) => {
          ids.push(item.id)
        })
        this.loadingb = true
        this.$post({
          url: "/app/order_queue/batSynchronize",
          data: {
            shop_id: this.activeName,
            ids: ids.join()
          },
          success: res => {
            this.$notify({
              title: this.$t('lg.成功'),
              type: 'success'
            });
            setTimeout(() => {
              this.loadingb = false
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => {
            setTimeout(() => {
              this.loadingb = false
            }, 1300);
          },
        })
      },
      order_status_fun(data) {
        let tit = ""
        switch (data) {
          case 0:
            tit = this.$t('lg.待同步')
            break
          case 1:
            tit = this.$t('lg.成功')
            break
          case 2:
            tit = this.$t('lg.失败')
            break
          case 3:
            tit = this.$t('lg.同步中')
            break
          case 4:
            tit = this.$t('lg.跳过')
            break
        }
        return tit
      },
      type_status_fun(data) {
        let tit = ""
        switch (data) {
          case 1:
            tit = this.$t('lg.下载订单')
            break
          case 2:
            tit = this.$t('lg.下载平台发货信息到DEAR')
            break
          case 3:
            tit = this.$t('lg.上传DEAR发货信息到平台')
            break
          case 4:
            tit = this.$t('lg.下载订单退货')
            break
          case 5:
            tit = this.$t('lg.作废销售订单')
            break
          case 6:
            tit = this.$t('lg.回传平台发货信息到DEAR')
            break
        }
        return tit
      },
      refund_status_fun(data) {
        let tit = ""
        switch (data) {
          case 'NO_REFUND':
            tit = this.$t('lg.无退款')
            break
          case 'REFUNDED':
            tit = this.$t('lg.全部退款')
            break
        }
        return tit
      },
      order_status_funs(data) {
        let tit = ""
        switch (data) {
          case 'DELETED':
            tit = this.$t('lg.已删除')
            break
          case 'CLOSE':
            tit = this.$t('lg.已关闭')
            break
          case 'CANCEL':
            tit = this.$t('lg.已取消')
            break
          case 'UNKNOWN':
            tit = this.$t('lg.未知')
            break
          case 'UNPAID':
            tit = this.$t('lg.未付款')
            break
          case 'PART_PAID':
            tit = this.$t('lg.部分付款')
            break
          case 'NOT_SHIPPED':
            tit = this.$t('lg.未发货')
            break
          case 'PART_SHIPPED':
            tit = this.$t('lg.部分发货')
            break
          case 'SHIPPED':
            tit = this.$t('lg.已发货')
            break
          case 'REJECTED':
            tit = this.$t('lg.已拒收')
            break
          case 'BILL_SHIPPED':
            tit = this.$t('lg.已寄票')
            break
          case 'BILL_COMPLETE':
            tit = this.$t('lg.已收票')
            break
          case 'PAUSE':
            tit = this.$t('lg.暂停')
            break
          case 'LOCKED':
            tit = this.$t('lg.锁定')
            break
          case 'COMPLETE':
            tit = this.$t('lg.已完成')
            break
        }
        return tit
      },
      // 跳过
      confirmskip(row) {
        this.$post({
          url: "/app/order_queue/skip",
          data: {
            shop_id: this.activeName,
            id: row.id,
          },
          success: res => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => { },
        })
      },
      // 同步
      confirmsynchronize(row) {
        this.btn_loadingb = true
        this.$post({
          url: "/app/order_queue/synchronize",
          data: {
            shop_id: this.activeName,
            id: row.id,
          },
          success: (res) => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.btn_loadingb = false
            }, 1300);
            this.$nextTick(() => {
              this.pagechage(this.page)
            })
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loadingb = false
            }, 1300);
          },
        })
      },
      // 详情
      lookdata(data) {
        this.info = data
        this.order_id = data.order_id
        this.getdata()
      },
      getdata() {
        this.$post({
          url: "/app/orders_goods/goodsList",
          data: {
            order_id: this.order_id,
          },
          success: (res) => {
            this.gooddata = res.data
            this.show = true
          },
          tip: () => {
          },
        })
      },
    },
    created() {
      this.gettablist()
    },
  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 10px 20px 0px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
    }
    .tablebox {
      width: 100%;
      padding: 20px;
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
    }
    .dataselect {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /deep/.el-dialog {
      min-width: 400px !important;
    }
  }
</style>